
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Use Modern Treasury with Plaid Auth to send and receive payments"
};
export const partnerProps = {
  partner: 'Modern Treasury',
  clientLibrary: 'modern_treasury',
  subtitle: metadata.description,
  registrationUrl: 'https://app.moderntreasury.com/sign_up',
  apiUrl: 'https://docs.moderntreasury.com/reference',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Plaid and `}<a parentName="p" {...{
        "href": "https://www.moderntreasury.com/"
      }}>{`Modern Treasury`}</a>{` have partnered to offer businesses a secure
and streamlined way to manage payment operations. Plaid enables businesses to instantly authenticate a
counter-party's bank account. With the Modern Treasury API, teams can initiate payments via ACH, Wire, and RTP
through a single implementation. Modern Treasury's solution supports the full cycle of money movement for
growing businesses including payment initiation, approvals, monitoring, and reconciliation. As part of
the integration, Modern Treasury customers can utilize Plaid's APIs for real-time balance information.`}</p>
    <p>{`With the Plaid + Modern Treasury integration, counter-parties can onboard with ease by
verifying their accounts in seconds using Plaid Link, a drop-in front-end module. Plaid
Link handles input validation, error handling, and multi-factor authentication, providing
a seamless onboarding experience to users of the Modern Treasury web portal.`}</p>
    <p>{`To get started sign up for `}<a parentName="p" {...{
        "href": "https://dashboard.plaid.com/developers/keys"
      }}>{`Plaid API keys`}</a>{`.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthIdentityInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
